import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Loader2 } from "lucide-react";

export default function AuthSuccess(): JSX.Element {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      localStorage.setItem('token', token);
      
      // Redirect to dashboard
      setTimeout(() => {
        history.push('/dashboard');
        window.location.reload();
      }, 1000);
    } else {
      history.push('/login');
    }
  }, [location, history]);

  return (
    <div className="h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary mx-auto" />
        <p className="text-muted-foreground font-medium animate-pulse tracking-widest uppercase text-[10px]">
          Authenticating...
        </p>
      </div>
    </div>
  );
}
